export default "__VITE_ASSET__B3DoEv$W__"